var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "提示",
        visible: _vm.dialogVisible,
        width: "840px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { attrs: { id: "print" } }, [
        _c("table", { staticClass: "gh-table" }, [
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                { staticStyle: { padding: "0" }, attrs: { colspan: "24" } },
                [_vm._v("调拨单")]
              ),
            ]),
            _c("tr", [
              _c("th", { attrs: { colspan: "4" } }, [_vm._v("调出仓库：")]),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(_vm.data.outPositionName)),
              ]),
              _c("th", { attrs: { colspan: "4" } }, [_vm._v("调入仓库：")]),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(_vm.data.inPositionName)),
              ]),
            ]),
            _c("tr", [
              _c("th", { attrs: { colspan: "4" } }, [_vm._v("单据时间：")]),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(_vm.data.ordTime)),
              ]),
              _c("th", { attrs: { colspan: "4" } }, [_vm._v("业务时间：")]),
              _c("td", { attrs: { colspan: "8" } }, [
                _vm._v(_vm._s(_vm.data.businessTime)),
              ]),
            ]),
            _c("tr", [
              _c("th", { attrs: { colspan: "4" } }, [_vm._v("调拨类型：")]),
              _c("td", { attrs: { colspan: "20" } }, [
                _vm._v(_vm._s(_vm.data.alloTypeName)),
              ]),
            ]),
            _c("tr", { staticClass: "fixed-header" }, [
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("药品编码")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("药品名称")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("供应商")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("生产商")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("品质")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("产地")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("生产日期")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("保质期")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("批次号")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("出库数量")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("成本单价")]),
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("成本金额")]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.list, function (value, index) {
              return _c("tr", { key: index }, [
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.materielCode)),
                ]),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.materielName)),
                ]),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.supplierName)),
                ]),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.manufacturerName)),
                ]),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.toJson(_vm.jsonStr.qualitySign, value.qualitySign)
                    )
                  ),
                ]),
                _c("td", { attrs: { colspan: "2" } }),
                _c("td", { attrs: { colspan: "2" } }),
                _c("td", { attrs: { colspan: "2" } }),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.batchCode)),
                ]),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.number)),
                ]),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.costPrice)),
                ]),
                _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(value.costAmount)),
                ]),
              ])
            }),
            0
          ),
          _c("tfoot", [
            _c("tr", [
              _c("th", { attrs: { colspan: "4" } }, [_vm._v("仓管签字：")]),
              _c("th", { attrs: { colspan: "20" } }),
            ]),
          ]),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handlePrint } },
            [_vm._v("打 印")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }